module.exports = __webpack_public_path__ + "static/media/elipse.fff82ced.svg";